/**
 * Controlant adapter — IOT-ADAPTER-LIBRARY-1.
 *
 * Tier: third-party-tier-2 (pharma cold-chain specialist; FDA / EU GDP)
 * Category: cold_chain
 *
 * TYPE-ONLY: capability matrix declared; live API calls throw
 * VendorNotIntegratedError. Full integration scheduled once Controlant
 * Saga / SCALE API credentials are provisioned.
 *
 * Supported devices: Saga Logger family (single-use and reusable cellular
 * temperature loggers for pharma distribution). Compliance surface:
 * FDA 21 CFR Part 11, EU Annex 11, FSMA-204 traceability lot codes carried
 * end-to-end.
 *
 * Patent anchor: F-IOT-ADAPTER-001.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const CONTROLANT_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: false,
      readable: true,
      range: [60, 86400],
      requiresActivation: true,
      unit: 'seconds',
      description: 'Telemetry interval (set at provisioning; single-use loggers cannot be reconfigured OTA)',
    },
    temp_alert_max_c: {
      pushable: false,
      readable: true,
      range: [-40, 85],
      requiresActivation: true,
      unit: '°C',
      description: 'Upper temperature alert threshold (provisioning-time; immutable post-deployment)',
    },
    temp_alert_min_c: {
      pushable: false,
      readable: true,
      range: [-40, 85],
      requiresActivation: true,
      unit: '°C',
      description: 'Lower temperature alert threshold (provisioning-time; immutable post-deployment)',
    },
  },
  telemetryTypes: [
    'temperature_c', 'humidity_pct', 'gps_position', 'battery_soc_pct',
    'cell_signal_dbm',
  ],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: true,
  rollbackSupported: false,
  pushLatencyExpectedMs: 0,
};

export class ControlantAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'controlant', CONTROLANT_CAPABILITIES);
  }
}

export function createControlantAdapterFactory() {
  return (device) => new ControlantAdapter(device);
}
